import React, { useState } from 'react';
import { translations } from '../data/translations';
import { useLanguage } from '../context/LanguageContext';

function ContactForm() {
  const { t } = useLanguage();
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    email: '',
    question: ''
  });
  const [status, setStatus] = useState({ type: '', message: '' });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setStatus({ type: '', message: '' });

    try {
      const response = await fetch('/api/contact', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      });

      const data = await response.json();

      if (data.success) {
        setStatus({ type: 'success', message: t(translations.contactForm.success) });
        setFormData({ name: '', phone: '', email: '', question: '' });
      } else {
        setStatus({ type: 'error', message: t(translations.contactForm.error) });
      }
    } catch (error) {
      setStatus({ type: 'error', message: t(translations.contactForm.error) });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section id="contact-form" className="contact-form-section">
      <div className="container">
        <h2 className="section-title">{t(translations.contactForm.title)}</h2>
        <p className="section-subtitle">{t(translations.contactForm.subtitle)}</p>

        <div className="contact-form-container">
          <form onSubmit={handleSubmit} className="contact-form">
            <div className="form-row">
              <div className="form-group">
                <label htmlFor="name">{t(translations.contactForm.name)} *</label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  placeholder={t(translations.contactForm.namePlaceholder)}
                  required
                />
              </div>
              <div className="form-group">
                <label htmlFor="phone">{t(translations.contactForm.phone)} *</label>
                <input
                  type="tel"
                  id="phone"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  placeholder={t(translations.contactForm.phonePlaceholder)}
                  required
                />
              </div>
            </div>

            <div className="form-group">
              <label htmlFor="email">{t(translations.contactForm.email)}</label>
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                placeholder={t(translations.contactForm.emailPlaceholder)}
              />
            </div>

            <div className="form-group">
              <label htmlFor="question">{t(translations.contactForm.question)}</label>
              <textarea
                id="question"
                name="question"
                value={formData.question}
                onChange={handleChange}
                placeholder={t(translations.contactForm.questionPlaceholder)}
                rows="4"
              />
            </div>

            {status.message && (
              <div className={`form-status ${status.type}`}>
                {status.message}
              </div>
            )}

            <button
              type="submit"
              className="btn btn-primary btn-large btn-submit"
              disabled={isSubmitting}
            >
              {isSubmitting ? t(translations.contactForm.sending) : t(translations.contactForm.submit)}
            </button>

            <p className="form-privacy">{t(translations.contactForm.privacy)}</p>
          </form>
        </div>
      </div>
    </section>
  );
}

export default ContactForm;
